import React, { useCallback, useContext, useEffect, useState } from 'react';
import PageTitle from '../../Components/PageTitle';
import { isNumeric, monthDataSelect } from '../../Constants/constants';
import Select from 'react-select';
import Swal from 'sweetalert2';
import { ConfigContext } from '../../Context/ConfigContext';
import axios from 'axios';
import { SubmitBtn, SubmitButton } from '../../Components/InputElements';
import { decodeData } from '../../Constants/constants';
import { useLocation } from 'react-router-dom';
import { currentDateAndTime } from '../../Constants/constants';

const LeaveGeneralSettings = () => {
    const { apiURL, apiHeaderJSON ,permissions,setPermissions} = useContext(ConfigContext);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const encodedData = queryParams.get("abs");
    const decodedData = encodedData ? decodeData(encodedData,permissions) : [];
    const [loading, setLoading] = useState(false);
    const [postLoading, setPostLoading] = useState(false);
    const [leaveOptions, setLeaveOptions] = useState([
        { value: "Earned Leave", label: "Earned Leave" },
        { value: "Casual Leave", label: "Casual Leave" },
        { value: "Sick Leave", label: "Sick Leave" },
    ]);
    const [formData, setFormData] = useState({
        monthFromLeaveStart: "",
        adminAccessToLeave: "1",
        adminAdjustLeaveBalance: "1",
        nearestAccrualUnit: null,
        // proRate: null,
        // fixCutOff: "0",
        closeLeaveBalance: null,
        approvalLevels: "1",
        parallelApproval: null,
        absentDaysTreated: null,
        absentHierarchy: [
            "Apply against CO (or select type of leave)",
            "Apply against CL (if CO is not balance)",
            "Apply against SL (if CL is not balance)",
            "Apply against PL (If SL is not balance)"
        ],
        compOff: null,
        leaveAfterSalary: null,
        daysToApplyLeaveAfterSalary: null,
        daysToApplyLeave: false,
        // rmDurationToApprovedOrReject: false,
        // leaveRequestMove: false,
        subordinateLeave: false,
        adminApprovedRejectRequest: false,
        adminApplyLeaveBehalfEmployee: false,
        // selectApprovedManyRequest: ["0", "0", "0"],
        // adminAccessToDeleteApprovedRequest: "0",
        level1_rm_notification: ["0", "0", "3"],
        level2_rm_notification: ["0", "0", "3"],
        employeeApprovalNotification: ["0", "0", "3"],
        approvalLevelNotification: null,
        employeeRejectionNotification: ["0", "0", "3"],
        rejectionLevelNotification: null,
        date: currentDateAndTime(),
    })

    const getLeaveGeneralSettingInfo = () => {
        const headers = apiHeaderJSON;
        setLoading(true);
        axios.get(`${apiURL}Masters/GetLeaveGeneralSettings`, { headers }).then((response) => {
            const { success } = response.data;
            // console.log('getLeaveGeneralSettingInfo ~ response', response);
            if (success === true) {
                let data = response.data;
                // console.log("data?.result[0]?.hirachy_for_absent_leave_cycle_start0",data?.result[0]?.leave_cycle_start_month)
                setFormData({
                    leave_setting_id: data?.result[0]?.leave_setting_id || 0,
                    monthFromLeaveStart: data?.result[0]?.leave_cycle_start_month || "",
                    adminAccessToLeave: data?.result[0]?.admin_access_leave_module || "1",
                    adminAdjustLeaveBalance: data?.result[0]?.admin_access_to_add_reduce_leave_balance_of_emp || "1",
                    nearestAccrualUnit: data?.result[0]?.round_off_leave_accrual || null,
                    // proRate: data?.result[0]?.pro_rate_leave_balance || null,
                    // fixCutOff: data?.result[0]?.fixed_cut_off_for_pro_rate || "0",
                    closeLeaveBalance: data?.result[0]?.display_closing_leave_balance || null,
                    approvalLevels: data?.result[0]?.leave_approve_level || "1",
                    parallelApproval: data?.result[0]?.parallel_approve || null,
                    absentDaysTreated: data?.result[0]?.hirachy_for_absent_day || null,
                    absentHierarchy: JSON.parse(data?.result[0]?.hirachy_for_absent_leave_cycle_start) || [
                        "Apply against CO (or select type of leave)",
                        "Apply against CL (if CO is not balance)",
                        "Apply against SL (if CL is not balance)",
                        "Apply against PL (If SL is not balance)"
                    ],
                    compOff: data?.result[0]?.comp_off_earned || null,
                    daysToApplyLeave: data?.result[0]?.day_to_apply_leave || null,
                    subordinateLeave: data?.result[0]?.RM_apply_leave_on_behalf_sub_emp || null,
                    adminApprovedRejectRequest: data?.result[0]?.admin_can_approve_reject_passing_L1_L2 || null,
                    adminApplyLeaveBehalfEmployee: data?.result[0]?.admin_apply_leave_on_behalf_emp || null,
                    level1_rm_notification: JSON.parse(data?.result[0]?.level1_rm_notification) || ["0", "0", "3"],
                    level2_rm_notification: JSON.parse(data?.result[0]?.level2_rm_notification) || ["0", "0", "3"],
                    employeeApprovalNotification: JSON.parse(data?.result[0]?.employee_approval_notification) || ["0", "0", "3"],
                    approvalLevelNotification: data?.result[0]?.approval_level_notification || null,
                    employeeRejectionNotification: JSON.parse(data?.result[0]?.employee_rejection_notification) || ["0", "0", "3"],
                    rejectionLevelNotification: data?.result[0]?.rejection_level_notification || null,
                });

            }
        });
        setLoading(false);
    }
    useEffect(() => {
        getLeaveGeneralSettingInfo();
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();
        setPostLoading(true);
        const headers = apiHeaderJSON;
        // setLoading(true);
       const formLeaveData={
        ...formData,
        date: currentDateAndTime(),
       }
        console.log("form Data =======>>>", formData);
        axios.post(`${apiURL}Masters/CreateLeaveGeneralSetting`,formLeaveData, { headers }).then((response) => {
            const { success } = response.data;
            // console.log("response =======>>>", response);

            if (success === true) {
                
                Swal.fire({
                    title: `<strong>${success ? 'Success' : 'Failed'}</strong>`,
                    text: response.data.message,
                    icon: success ? 'success' : 'error',
                    showConfirmButton: true,  // Show OK button
                }).then((result) => {
                    if (result.isConfirmed) {
                        // Optional: You can perform any action here after OK is clicked
                        setPostLoading(false);
                        getLeaveGeneralSettingInfo();  // Call your function after the alert is closed
                    }
                });

            } else {
                Swal.fire({
                    title: `<strong>${success ? 'Success' : 'Failed'}</strong>`,
                    text: response.data.message,
                    icon: success ? 'success' : 'error',
                    showConfirmButton: true,  // Show OK button
                }).then((result) => {
                    if (result.isConfirmed) {
                        // Optional: Action after the OK button is clicked
                        setPostLoading(false);
                    }
                });
            }

        })
    };


    const handleHierchy = (value) => {
        let temp = formData?.absentHierarchy;
        // console.log("handleHierchy ~ temp",temp);
        if (formData?.absentHierarchy?.length < 5 && !temp?.includes(value)) {
            temp?.push(value);
            // console.log("handleHierchy ~ temp ~ in",temp);
            setFormData({ ...formData, absentHierarchy: temp })
        }
    }

    const handleRemoveAbsentHierarchy = (value) => {
        let temp = formData?.absentHierarchy;
        temp = temp?.filter((val) => {
            if (val !== value) {
                return val;
            }
        });
        setFormData({ ...formData, absentHierarchy: temp })
    }

    const handleRadioChange = (name, value) => {
        console.log("handleRadioChange ~ name, value", name, value);
        if (name === 'admin_access_leave') {
            setFormData({ ...formData, adminAccessToLeave: value });
        }
        else if (name === 'admin_adjust_leave_balance') {
            setFormData({ ...formData, adminAdjustLeaveBalance: value });
        }
        else if (name === "leave_accruals") {
            setFormData({ ...formData, leaveAccrual: value, dayOfLeaveAccrual: false });
        }
        else if (name === "date_of_leave_accrual") {
            setFormData({ ...formData, dayOfLeaveAccrual: formData?.leaveAccrual ? value : false });
        }
        else if (name === "nearest_accrual_unit") {
            setFormData({ ...formData, nearestAccrualUnit: value });
        }
        else if (name === "closing_leave_balance") {
            setFormData({ ...formData, closeLeaveBalance: value });
        }
        // else if (name === "cut_off_pro_rate") {
        //     setFormData({ ...formData, proRate: value });
        // }
        // else if (name === "fix_cut_off_pro_rate") {
        //     if (isNumeric(value)) {
        //         setFormData({ ...formData, fixCutOff: value });
        //     }
        // }
        else if (name === "approval_levels") {

            setFormData({ ...formData, approvalLevels: value, parallelApproval: value === "2" ? "1" : null });
        }
        else if (name === "parallel_approvals") {
            setFormData({ ...formData, parallelApproval: value });
        }
        else if (name === "absent_days_treated") {
            setFormData({
                ...formData, absentDaysTreated: value, absentHierarchy: value === "2" ? formData?.absentHierarchy : [
                    "Apply against CO (or select type of leave)",
                    "Apply against CL (if CO is not balance)",
                    "Apply against SL (if CL is not balance)",
                    "Apply against PL (If SL is not balance)"
                ]
            });
        }
        else if (name === "comp_off") {
            setFormData({ ...formData, compOff: value });
        }
        else if (name === "leave_after_salary") {
            setFormData({ ...formData, leaveAfterSalary: value });
        }
        else if (name === "days_leave_to_apply_after_salary") {
            let temp = `${value}`;
            if (temp?.length < 4 && !temp?.includes("-") && !temp?.includes(".")) {
                setFormData({ ...formData, daysToApplyLeaveAfterSalary: value });
            }
        }
        else if (name === "days_leave_to_apply") {
            let temp = `${value}`;
            if (temp?.length < 4 && !temp?.includes("-") && !temp?.includes(".")) {
                setFormData({ ...formData, daysToApplyLeave: value });
            }
        }
        else if (name === "rm_time_duration") {
            let temp = `${value}`;
            if (temp?.length < 4 && !temp?.includes("-") && !temp?.includes(".")) {
                setFormData({ ...formData, rmDurationToApprovedOrReject: value });
            }
        }
        else if (name === "request_move_to") {
            setFormData({ ...formData, leaveRequestMove: value });
        }
        else if (name === "subordinate_leave") {
            setFormData({ ...formData, subordinateLeave: value });
        }
        else if (name === "admin_approved_reject_request") {
            setFormData({ ...formData, adminApprovedRejectRequest: value });
        }
        else if (name === "admin_apply_leave_behalf_employee") {
            setFormData({ ...formData, adminApplyLeaveBehalfEmployee: value });
        }
        else if (name === "select_requests_approved_or_reject") {
            let temp = formData?.selectApprovedManyRequest;
            // console.log(formData?.selectApprovedManyRequest[0],"---",formData?.selectApprovedManyRequest[0]==="0"? "1":"0")
            if (value === "1") {
                temp?.splice(0, 1, formData?.selectApprovedManyRequest[0] === "0" ? "1" : "0")
            }
            else if (value === "2") {
                temp?.splice(1, 1, formData?.selectApprovedManyRequest[1] === "0" ? "1" : "0")
            }
            else if (value === "3") {
                temp?.splice(2, 1, formData?.selectApprovedManyRequest[2] === "0" ? "1" : "0")
            }
            // console.log("temp",temp);
            setFormData({ ...formData, selectApprovedManyRequest: temp });
        }
        else if (name === "level1_rm_notification") {
            let temp = formData?.level1_rm_notification;
            // console.log(formData?.selectApprovedManyRequest[0],"---",formData?.selectApprovedManyRequest[0]==="0"? "1":"0")
            if (value === "1") {
                temp?.splice(0, 1, formData?.level1_rm_notification[0] === "0" ? "1" : "0")
            }
            else if (value === "2") {
                temp?.splice(1, 1, formData?.level1_rm_notification[1] === "0" ? "1" : "0")
            }
            else if (value === "3") {
                temp?.splice(2, 1, formData?.level1_rm_notification[2] === "0" ? "1" : "0")
            }
            // console.log("temp",temp);
            setFormData({ ...formData, level1_rm_notification: temp });
        }
        else if (name === "level2_rm_notification") {
            let temp = formData?.level2_rm_notification;
            // console.log(formData?.selectApprovedManyRequest[0],"---",formData?.selectApprovedManyRequest[0]==="0"? "1":"0")
            if (value === "1") {
                temp?.splice(0, 1, formData?.level2_rm_notification[0] === "0" ? "1" : "0")
            }
            else if (value === "2") {
                temp?.splice(1, 1, formData?.level2_rm_notification[1] === "0" ? "1" : "0")
            }
            else if (value === "3") {
                temp?.splice(2, 1, formData?.level2_rm_notification[2] === "0" ? "1" : "0")
            }
            // console.log("temp",temp);
            setFormData({ ...formData, level2_rm_notification: temp });
        }
        else if (name === "employee_approval_notification") {
            let temp = formData?.employeeApprovalNotification;
            // console.log(formData?.selectApprovedManyRequest[0],"---",formData?.selectApprovedManyRequest[0]==="0"? "1":"0")
            if (value === "1") {
                temp?.splice(0, 1, formData?.employeeApprovalNotification[0] === "0" ? "1" : "0")
            }
            else if (value === "2") {
                temp?.splice(1, 1, formData?.employeeApprovalNotification[1] === "0" ? "1" : "0")
            }
            else if (value === "3") {
                temp?.splice(2, 1, formData?.employeeApprovalNotification[2] === "0" ? "1" : "0")
            }
            // console.log("temp",temp);
            setFormData({ ...formData, employeeApprovalNotification: temp });
        }
        else if (name === "approval_level_notification") {
            setFormData({ ...formData, approvalLevelNotification: value });
        }
        else if (name === "employee_rejection_notification") {
            let temp = formData?.employeeRejectionNotification;
            // console.log(formData?.selectApprovedManyRequest[0],"---",formData?.selectApprovedManyRequest[0]==="0"? "1":"0")
            if (value === "1") {
                temp?.splice(0, 1, formData?.employeeRejectionNotification[0] === "0" ? "1" : "0")
            }
            else if (value === "2") {
                temp?.splice(1, 1, formData?.employeeRejectionNotification[1] === "0" ? "1" : "0")
            }
            else if (value === "3") {
                temp?.splice(2, 1, formData?.employeeRejectionNotification[2] === "0" ? "1" : "0")
            }
            // console.log("temp",temp);
            setFormData({ ...formData, employeeRejectionNotification: temp });
        }
        else if (name === "rejection_level_notification") {
            setFormData({ ...formData, rejectionLevelNotification: value });
        }
        else if (name === "admin_access_to_delete_approved_request") {
            setFormData({ ...formData, adminAccessToDeleteApprovedRequest: value });
        }
    };

    // console.log("LeaveGeneralSettings ~ formData", formData);
    return (
        <div>
            {!loading ?
                <div class="main-content" >
                    <div class="page-content">
                        <div className="container-fluid">
                            <br />
                            <PageTitle title={`Leave General Settings`} primary={`Home`} />
                            <div className='card'>
                                <div className="card-header align-items-center d-flex">
                                    <h4 className="card-title mb-0 flex-grow-1">Leave General Settings</h4>
                                </div>
                                <div className="card-body">
                                    <div className="row gy-4">
                                        <div className="col-md-12">
                                            <form className="row settings-form">
                                                {/* Leave Cycle Setting */}
                                                <div className="col-md-6 mt-3 mb-3 settings-section">
                                                    <label>Which month the Leave Cycle Starts</label>
                                                    <Select
                                                        id="leave_cycle"
                                                        name="leave_cycle"
                                                        value={monthDataSelect?.find((val) => val?.value === formData?.monthFromLeaveStart)}
                                                        onChange={(selectedOption) => setFormData({ ...formData, monthFromLeaveStart: selectedOption })}
                                                        isDisabled={(!decodedData?.includes(2) && !decodedData?.includes(3))}
                                                        options={monthDataSelect}
                                                        placeholder="Select Month"
                                                    />
                                                </div>
                                                {/* Admin Access Setting */}
                                                <div className="col-md-6 mt-3 settings-section">
                                                    <div>
                                                        <label>Should Admin has access to leave module to Approve,
                                                            Reject or Cancel the Leaves</label>
                                                    </div>
                                                    <div className="form-check form-check-inline mt-2">
                                                        <input
                                                            type="radio"
                                                            id="admin_access_leave_yes"
                                                            name="admin_access_leave"
                                                            value="1"
                                                            checked={formData?.adminAccessToLeave === "1"}
                                                            onChange={() => handleRadioChange("admin_access_leave", "1")}
                                                            className="form-check-input"
                                                        />
                                                        <label htmlFor="admin_access_leave_yes" className="form-check-label">Yes</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="admin_access_leave_no"
                                                            name="admin_access_leave"
                                                            value="0"
                                                            checked={formData?.adminAccessToLeave === "0"}
                                                            onChange={() => handleRadioChange("admin_access_leave", "0")}
                                                            className="form-check-input"
                                                        />
                                                        <label htmlFor="admin_access_leave_no" className="form-check-label">No</label>
                                                    </div>
                                                </div>
                                                {/* Admin adjust the leaves Setting */}
                                                <div className="col-md-6 mt-4 settings-section">
                                                    <div>
                                                        <label style={{opacity:"0.5"}}>Can Admin adjust the leaves by adding or reducing the
                                                            leaves balances for Employee</label>
                                                    </div>
                                                    <div className="form-check form-check-inline mt-2">
                                                        <input
                                                            type="radio"
                                                            id="admin_adjust_leave_balance_yes"
                                                            name="admin_adjust_leave_balance"
                                                            value="1"
                                                            checked={formData?.adminAdjustLeaveBalance === "1"}
                                                            onChange={() => handleRadioChange("admin_adjust_leave_balance", "1")}
                                                            className="form-check-input"
                                                            disabled
                                                        />
                                                        <label htmlFor="admin_adjust_leave_balance_yes" className="form-check-label">Yes</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="admin_adjust_leave_balance_no"
                                                            name="admin_adjust_leave_balance"
                                                            value="0"
                                                            checked={formData?.adminAdjustLeaveBalance === "0"}
                                                            onChange={() => handleRadioChange("admin_adjust_leave_balance", "0")}
                                                            className="form-check-input"
                                                            disabled
                                                        />
                                                        <label htmlFor="admin_adjust_leave_balance_no" className="form-check-label">No</label>
                                                    </div>
                                                </div>
                                                {/* Fixed holiday Setting */}
                                                {/* <div className="col-md-6 mt-3 settings-section">
                                                    <div>
                                                        <label>Fixed holiday is part of Continuous Leaves?</label>
                                                    </div>
                                                    <div className="form-check form-check-inline mt-2">
                                                        <input
                                                            type="radio"
                                                            id="rm_apply_regularization_yes"
                                                            name="rm_apply_regularization"
                                                            value="yes"
                                                            className="form-check-input"
                                                        />
                                                        <label htmlFor="rm_apply_regularization_yes" className="form-check-label">Yes</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="rm_apply_regularization_no"
                                                            name="rm_apply_regularization"
                                                            value="no"
                                                            className="form-check-input"
                                                        />
                                                        <label htmlFor="rm_apply_regularization_no" className="form-check-label">No</label>
                                                    </div>
                                                </div> */}
                                                {/* leave accrual nearest to 0.5 Unit setting */}
                                                <div className="col-md-6 mt-3 settings-section">
                                                    <div>
                                                        <label>Should we round of the leave accrual nearest to 0.5 Unit</label>
                                                    </div>
                                                    <div className="form-check form-check-inline mt-2">
                                                        <input
                                                            type="radio"
                                                            id="nearest_accrual_unit_yes"
                                                            name="nearest_accrual_unit"
                                                            value="1"
                                                            checked={formData?.nearestAccrualUnit === "1"}
                                                            onChange={() => handleRadioChange("nearest_accrual_unit", "1")}
                                                            className="form-check-input"
                                                        />
                                                        <label htmlFor="nearest_accrual_unit_yes" className="form-check-label">Yes</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="nearest_accrual_unit_no"
                                                            name="nearest_accrual_unit"
                                                            value="0"
                                                            checked={formData?.nearestAccrualUnit === "0"}
                                                            onChange={() => handleRadioChange("nearest_accrual_unit", "0")}
                                                            className="form-check-input"
                                                        />
                                                        <label htmlFor="nearest_accrual_unit_no" className="form-check-label">No</label>
                                                    </div>
                                                </div>
                                                {/* pro-rate the 1st month leaves setting */}
                                                {/* <div className="col-md-6 mt-4 settings-section">
                                                    <div>
                                                        <label>How to pro-rate the 1st month leaves to New Joined
                                                            Employee </label>
                                                    </div>
                                                    <div className="form-check form-check-inline mt-2">
                                                        <input
                                                            type="radio"
                                                            id="cut_off_pro_rate_yes"
                                                            name="cut_off_pro_rate"
                                                            value="1"
                                                            checked={formData?.proRate === "1"}
                                                            onChange={() => handleRadioChange("cut_off_pro_rate", "1")}
                                                            className="form-check-input"
                                                        />
                                                        <label htmlFor="cut_off_pro_rate_yes" className="form-check-label">Fixed Cut Off date for the Accrual </label>
                                                        {formData?.proRate === "1" && (
                                                            <div className="w-100 mx-4 mt-2">
                                                                <input
                                                                    type="text"
                                                                    id="days_leave_to_apply_yes"
                                                                    name="days_leave_to_apply"
                                                                    placeholder='In days'
                                                                    value={formData?.fixCutOff}
                                                                    onChange={(e) => handleRadioChange("fix_cut_off_pro_rate", e.target.value)}
                                                                    className="form-control w-100"
                                                                />
                                                            </div>
                                                        )}
                                                    </div> <br />
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="cut_off_pro_rate_no"
                                                            name="cut_off_pro_rate"
                                                            value="2"
                                                            checked={formData?.proRate === "2"}
                                                            onChange={() => handleRadioChange("cut_off_pro_rate", "2")}
                                                            className="form-check-input"
                                                        />
                                                        <label htmlFor="cut_off_pro_rate_no" className="form-check-label">No Cut Off</label>
                                                        <br />
                                                        <small className=' text-muted'>(To be calculated on the basis of no of day present in the 1st Month.)</small>
                                                    </div>
                                                </div> */}
                                                {/* display closing leave balance setting */}
                                                <div className="col-md-6 mt-4 settings-section">
                                                    <div>
                                                        <label>Would you like to display closing leave balance in Pay Slip</label>
                                                    </div>
                                                    <div className="form-check form-check-inline mt-2">
                                                        <input
                                                            type="radio"
                                                            id="closing_leave_balance_yes"
                                                            name="closing_leave_balance"
                                                            value="1"
                                                            checked={formData?.closeLeaveBalance === "1"}
                                                            onChange={() => handleRadioChange("closing_leave_balance", "1")}
                                                            className="form-check-input"
                                                        />
                                                        <label htmlFor="closing_leave_balance_yes" className="form-check-label">Yes</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="closing_leave_balance_no"
                                                            name="closing_leave_balance"
                                                            value="0"
                                                            checked={formData?.closeLeaveBalance === "0"}
                                                            onChange={() => handleRadioChange("closing_leave_balance", "0")}
                                                            className="form-check-input"
                                                        />
                                                        <label htmlFor="closing_leave_balance_no" className="form-check-label">No</label>
                                                    </div>
                                                </div>
                                                {/* Admin Approval Levels Setting */}
                                                <div className="col-md-6 mt-4 settings-section">
                                                    <div>
                                                        <label>How many Levels approval to be set</label>
                                                    </div>
                                                    <div className="form-check">
                                                        <input
                                                            type="checkbox"
                                                            id="approval_levels1"
                                                            name="approval_levels1"
                                                            value="1"
                                                            checked={formData?.approvalLevels === "1" || formData?.approvalLevels === "2"}
                                                            onChange={() => handleRadioChange('approval_levels', '1')}
                                                            className="form-check-input"
                                                        />
                                                        <label htmlFor="approval_levels1" className="form-check-label">Level1</label>
                                                    </div>
                                                    <div className="form-check">
                                                        <input
                                                            type="checkbox"
                                                            id="approval_levels2"
                                                            name="approval_levels2"
                                                            value="2"
                                                            checked={formData?.approvalLevels === "2"}
                                                            onChange={(e) => handleRadioChange('approval_levels', `${e.target.checked ? 2 : 1}`)}
                                                            className="form-check-input"
                                                        />
                                                        <label htmlFor="approval_levels2" className="form-check-label">Level2</label>
                                                    </div>

                                                    {formData?.approvalLevels === "2" &&
                                                        <div className='mt-3' style={{ marginLeft: '30px' }}>
                                                            <div>
                                                                <label>Do you want parallel approvals <br />
                                                                    <small className='text-muted'>({formData?.parallelApproval == '1' ? 'Will allow Level1 OR Level2 to act regardless another level action' : 'Level2 will be able to act only once Level1 has Approved'})</small>
                                                                </label>
                                                            </div>
                                                            <div className="form-check form-check-inline mt-2">
                                                                <input
                                                                    type="radio"
                                                                    id="parallel_approvals_yes"
                                                                    name="parallel_approvals"
                                                                    value="1"
                                                                    checked={formData?.parallelApproval === '1'}
                                                                    onChange={() => handleRadioChange('parallel_approvals', '1')}
                                                                    className="form-check-input"
                                                                />
                                                                <label htmlFor="parallel_approvals_yes" className="form-check-label">Yes</label>
                                                            </div>
                                                            <div className="form-check form-check-inline">
                                                                <input
                                                                    type="radio"
                                                                    id="parallel_approvals_no"
                                                                    name="parallel_approvals"
                                                                    value="0"
                                                                    checked={formData?.parallelApproval === '0'}
                                                                    onChange={() => handleRadioChange('parallel_approvals', '0')}
                                                                    className="form-check-input"
                                                                />
                                                                <label htmlFor="parallel_approvals_no" className="form-check-label">No</label>
                                                            </div>
                                                        </div>}
                                                </div>
                                                {/* hierarchy for absent days to treated setting */}
                                                <div className="col-md-6 mt-4 settings-section">
                                                    <div>
                                                        <label style={{opacity:"0.5"}}>What should be the hierarchy for which absent days to be
                                                            treated</label>
                                                    </div>
                                                    <div className="form-check form-check-inline mt-2">
                                                        <input
                                                            type="radio"
                                                            id="absentDaysTreated_1"
                                                            name="absentDaysTreated"
                                                            value="1"
                                                            checked={formData?.absentDaysTreated === "1"}
                                                            onChange={() => handleRadioChange("absent_days_treated", "1")}
                                                            className="form-check-input"
                                                            disabled
                                                        />
                                                        <label htmlFor="absentDaysTreated_1" className="form-check-label">Consider absent <small className='text-muted'>(untill employee apply for a leave or apply for time regularization.)</small> </label>
                                                    </div><br />
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="absentDaysTreated_2"
                                                            name="absentDaysTreated"
                                                            value="2"
                                                            checked={formData?.absentDaysTreated === "2"}
                                                            onChange={() => handleRadioChange("absent_days_treated", "2")}
                                                            className="form-check-input"
                                                            disabled
                                                        />
                                                        <label htmlFor="absentDaysTreated_2" className="form-check-label">Auto apply from the balance leave
                                                        </label>
                                                    </div>
                                                    {formData?.absentDaysTreated === "2" && (
                                                        <div className=" mx-4 mt-1 settings-section">
                                                            <label>Hierarchy for auto apply leave while payroll process</label>
                                                            {formData?.absentHierarchy?.length < 4 && (<select value={""} className='form-control' onChange={(e) => handleHierchy(e.target.value)} >
                                                                <option value="" selected disabled >Select hierarchy</option>
                                                                {Array.isArray(formData?.absentHierarchy) && !formData?.absentHierarchy?.includes("Apply against CO (or select type of leave)") && <option value="Apply against CO (or select type of leave)">Apply against CO (or select type of leave)</option>}
                                                                {Array.isArray(formData?.absentHierarchy) && !formData?.absentHierarchy?.includes("Apply against CL (if CO is not balance)") && <option value="Apply against CL (if CO is not balance)">Apply against CL (if CO is not balance)</option>}
                                                                {Array.isArray(formData?.absentHierarchy) && !formData?.absentHierarchy?.includes("Apply against SL (if CL is not balance)") && <option value="Apply against SL (if CL is not balance)">Apply against SL (if CL is not balance)</option>}
                                                                {Array.isArray(formData?.absentHierarchy) && !formData?.absentHierarchy?.includes("Apply against PL (If SL is not balance)") && <option value="Apply against PL (If SL is not balance)">Apply against PL (If SL is not balance)</option>}
                                                            </select>)}
                                                            <div className=' mx-4'>
                                                                {formData?.absentHierarchy?.map((val, idx) => {
                                                                    return (
                                                                        <><small>{idx + 1}. {val} <span onClick={() => handleRemoveAbsentHierarchy(val)} style={{ fontSize: "1.2rem" }} className='cursorPointer text-primary'>x</span></small><br /></>
                                                                    );
                                                                })}
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                                {/* Comp off is earned Setting */}
                                                <div className="col-md-6 mt-4 settings-section">
                                                    <div>
                                                        <label style={{opacity:"0.5"}}>How the Comp off is earned</label>
                                                    </div>
                                                    <div className="form-check form-check-inline mt-2">
                                                        <input
                                                            type="radio"
                                                            id="comp_off_yes"
                                                            name="comp_off"
                                                            value="1"
                                                            checked={formData?.compOff === "1"}
                                                            onChange={() => handleRadioChange("comp_off", "1")}
                                                            className="form-check-input"
                                                            disabled
                                                        />
                                                        <label htmlFor="comp_off_yes" className="form-check-label">Auto Calculated on the basis of check in and check out time</label>
                                                    </div> <br />
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="comp_off_no"
                                                            name="comp_off"
                                                            value="0"
                                                            checked={formData?.compOff === "0"}
                                                            onChange={() => handleRadioChange("comp_off", "0")}
                                                            className="form-check-input"
                                                            disabled
                                                        />
                                                        <label htmlFor="comp_off_no" className="form-check-label">Employee will apply to “EARN the Comp. Off”</label>
                                                    </div>
                                                </div>
                                                {/* apply for the leave after Salary Setting */}
                                                {/* <div className="col-md-6 mt-4 settings-section">
                                                    <div>
                                                        <label>Do you want to allow Employees to apply for the leave after Salary is processed for that month?</label>
                                                    </div>
                                                    <div className="form-check form-check-inline mt-2">
                                                        <input
                                                            type="radio"
                                                            id="leave_after_salary_yes"
                                                            name="leave_after_salary"
                                                            value="1"
                                                            checked={formData?.leaveAfterSalary === "1"}
                                                            onChange={() => handleRadioChange("leave_after_salary", "1")}
                                                            className="form-check-input"
                                                        />
                                                        <label htmlFor="leave_after_salary_yes" className="form-check-label">Yes</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="leave_after_salary_no"
                                                            name="leave_after_salary"
                                                            value="0"
                                                            checked={formData?.leaveAfterSalary === "0"}
                                                            onChange={() => handleRadioChange("leave_after_salary", "0")}
                                                            className="form-check-input"
                                                        />
                                                        <label htmlFor="leave_after_salary_no" className="form-check-label">No</label>
                                                    </div>
                                                    {formData?.leaveAfterSalary === "1" && (
                                                        <div className="mx-4 mt-3">
                                                            <label htmlFor="leave_applicable_after" className="form-label">How many days the Leave to be applied?</label>
                                                            <div className="w-100 mt-2">
                                                                <input
                                                                    type="number"
                                                                    id="days_leave_to_apply_yes"
                                                                    name="days_leave_to_apply"
                                                                    placeholder='In days'
                                                                    value={formData?.daysToApplyLeaveAfterSalary}
                                                                    onChange={(e) => handleRadioChange("days_leave_to_apply_after_salary", e.target.value)}
                                                                    className="form-control w-100"
                                                                />
                                                            </div>
                                                            <div className='mx-4 mt-3'>
                                                                <div className="col-md-6">
                                                                    <label htmlFor="leave_applicable_after" className="form-label"> Leave Applicable After:</label>
                                                                    <Select
                                                                        id="leave_applicable_after"
                                                                        name="leave_applicable_after"
                                                                        value={formData?.leaveApplicableAfter}
                                                                        onChange={(selectedOption) => handleFormData('leaveApplicableAfter', selectedOption)}
                                                                        options={monthOptions}
                                                                        placeholder="Select Your Leave Applicable After"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div> */}
                                                <div className="card-header align-items-center d-flex mt-5">
                                                    <h4 className="card-title mb-0 flex-grow-1">Leave Application Settings</h4>
                                                </div>
                                                {/* days the Leave to be applied Setting */}
                                                {/* <div className="col-md-6 mt-4 settings-section">
                                                    <div>
                                                        <label>Within how many days the Leave to be applied</label>
                                                    </div>
                                                    <div className="w-100 mt-2">
                                                        <input
                                                            type="number"
                                                            id="days_leave_to_apply_yes"
                                                            name="days_leave_to_apply"
                                                            placeholder='In days'
                                                            value={formData?.daysToApplyLeave}
                                                            onChange={(e) => handleRadioChange("days_leave_to_apply", e.target.value)}
                                                            className="form-control w-100"
                                                        />
                                                    </div>
                                                </div> */}
                                                {/* time duration for Reporting Manager Setting */}
                                                {/* <div className="col-md-6 mt-4 settings-section">
                                                    <div>
                                                        <label>What is the time duration for Reporting Manager to Approve or Reject the Request</label>
                                                    </div>
                                                    <div className="w-100 mt-2">
                                                        <input
                                                            type="number"
                                                            id="rm_time_duration_yes"
                                                            name="rm_time_duration"
                                                            placeholder='In days'
                                                            value={formData?.rmDurationToApprovedOrReject}
                                                            onChange={(e) => handleRadioChange("rm_time_duration", e.target.value)}
                                                            className="form-control w-100"
                                                        />
                                                         <label htmlFor="leave_after_salary_yes" className="form-check-label">Yes</label>
                                                    </div>
                                                </div> */}
                                                {/* request move to the reporting manager’s reporting manager Setting */}
                                                {/* <div className="col-md-6 mt-4 settings-section">
                                                    <div>
                                                        <label>Should request move to the reporting manager’s reporting manager if RM does not approve within set no. of days?</label>
                                                    </div>
                                                    <div className="form-check form-check-inline mt-2">
                                                        <input
                                                            type="radio"
                                                            id="request_move_to_yes"
                                                            name="request_move_to"
                                                            value="1"
                                                            checked={formData?.leaveRequestMove === "1"}
                                                            onChange={() => handleRadioChange("request_move_to", "1")}
                                                            className="form-check-input"
                                                        />
                                                        <label htmlFor="request_move_to_yes" className="form-check-label">Yes</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="request_move_to_no"
                                                            name="request_move_to"
                                                            value="0"
                                                            checked={formData?.leaveRequestMove === "0"}
                                                            onChange={() => handleRadioChange("request_move_to", "0")}
                                                            className="form-check-input"
                                                        />
                                                        <label htmlFor="request_move_to_no" className="form-check-label">No</label>
                                                    </div>
                                                </div> */}
                                                {/* RM Apply for subordinate leave request Setting */}
                                                <div className="col-md-6 mt-4 settings-section">
                                                    <div>
                                                        <label>Can RM Apply for subordinate leave request on behalf of Employee </label>
                                                    </div>
                                                    <div className="form-check form-check-inline mt-2">
                                                        <input
                                                            type="radio"
                                                            id="subordinate_leave_yes"
                                                            name="subordinate_leave"
                                                            value="1"
                                                            checked={formData?.subordinateLeave === "1"}
                                                            onChange={() => handleRadioChange("subordinate_leave", "1")}
                                                            className="form-check-input"
                                                        />
                                                        <label htmlFor="subordinate_leave_yes" className="form-check-label">Yes</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="subordinate_leave_no"
                                                            name="subordinate_leave"
                                                            value="0"
                                                            checked={formData?.subordinateLeave === "0"}
                                                            onChange={() => handleRadioChange("subordinate_leave", "0")}
                                                            className="form-check-input"
                                                        />
                                                        <label htmlFor="subordinate_leave_no" className="form-check-label">No</label>
                                                    </div>
                                                </div>
                                                {/* admin_approved_reject_request Setting */}
                                                <div className="col-md-6 mt-4 settings-section">
                                                    <div>
                                                        <label style={{opacity:"0.5"}}>Admin should have provision to Approve / Reject The request by passing the L1 & L2 level</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="admin_approved_reject_request_yes"
                                                            name="admin_approved_reject_request"
                                                            value="1"
                                                            checked={formData?.adminApprovedRejectRequest === "1"}
                                                            onChange={() => handleRadioChange("admin_approved_reject_request", "1")}
                                                            className="form-check-input"
                                                            disabled
                                                        />
                                                        <label htmlFor="admin_approved_reject_request_yes" className="form-check-label">Yes</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="admin_approved_reject_request_no"
                                                            name="admin_approved_reject_request"
                                                            value="0"
                                                            checked={formData?.adminApprovedRejectRequest === "0"}
                                                            onChange={() => handleRadioChange("admin_approved_reject_request", "0")}
                                                            className="form-check-input"
                                                            disabled
                                                        />
                                                        <label htmlFor="admin_approved_reject_request_no" className="form-check-label">No</label>
                                                    </div>
                                                </div>
                                                {/* admin_approved_reject_request Setting */}
                                                <div className="col-md-6 mt-4 settings-section">
                                                    <div>
                                                        <label style={{opacity:"0.5"}}>Admin should have provision to apply for leave request on behalf of employee</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="admin_apply_leave_behalf_employee_yes"
                                                            name="admin_apply_leave_behalf_employee"
                                                            value="1"
                                                            checked={formData?.adminApplyLeaveBehalfEmployee === "1"}
                                                            onChange={() => handleRadioChange("admin_apply_leave_behalf_employee", "1")}
                                                            className="form-check-input"
                                                            disabled
                                                        />
                                                        <label htmlFor="admin_apply_leave_behalf_employee_yes" className="form-check-label">Yes</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="admin_apply_leave_behalf_employee_no"
                                                            name="admin_apply_leave_behalf_employee"
                                                            value="0"
                                                            checked={formData?.adminApplyLeaveBehalfEmployee === "0"}
                                                            onChange={() => handleRadioChange("admin_apply_leave_behalf_employee", "0")}
                                                            className="form-check-input"
                                                            disabled
                                                        />
                                                        <label htmlFor="admin_apply_leave_behalf_employee_no" className="form-check-label">No</label>
                                                    </div>
                                                </div>
                                                {/* select many requests and approve / reject at one go Setting */}
                                                {/* <div className="col-md-6 mt-3 settings-section">
                                                    <div>
                                                        <label>Provision to select many requests and approve / reject at one go</label>
                                                    </div>
                                                    <div className="form-check">
                                                        <input
                                                            type="checkbox"
                                                            id="select_requests_approved_or_reject1"
                                                            name="select_requests_approved_or_reject"
                                                            value="1"
                                                            checked={formData?.selectApprovedManyRequest[0] === "1"}
                                                            onChange={() => handleRadioChange('select_requests_approved_or_reject', "1")}
                                                            className="form-check-input"
                                                        />
                                                        <label htmlFor="select_requests_approved_or_reject1" className="form-check-label">a) Level 1</label>
                                                    </div>
                                                    <div className="form-check">
                                                        <input
                                                            type="checkbox"
                                                            id="select_requests_approved_or_reject2"
                                                            name="select_requests_approved_or_reject"
                                                            value="1"
                                                            checked={formData?.selectApprovedManyRequest[1] === "1"}
                                                            onChange={(e) => handleRadioChange('select_requests_approved_or_reject', '2')}
                                                            className="form-check-input"
                                                        />
                                                        <label htmlFor="select_requests_approved_or_reject2" className="form-check-label">b) Level 2</label>
                                                    </div>
                                                    <div className="form-check">
                                                        <input
                                                            type="checkbox"
                                                            id="select_requests_approved_or_reject3"
                                                            name="select_requests_approved_or_reject"
                                                            value="1"
                                                            checked={formData?.selectApprovedManyRequest[2] === "1"}
                                                            onChange={(e) => handleRadioChange('select_requests_approved_or_reject', "3")}
                                                            className="form-check-input"
                                                        />
                                                        <label htmlFor="select_requests_approved_or_reject3" className="form-check-label">c) Admin</label>
                                                    </div>
                                                </div> */}
                                                {/* apply for leave request on behalf of employee Setting */}
                                                {/* <div className="col-md-6 mt-4 settings-section">
                                                    <div>
                                                        <label>Admin should have provision to apply for leave request on behalf of employee</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="admin_apply_leave_behalf_employee_yes"
                                                            name="admin_apply_leave_behalf_employee"
                                                            value="yes"
                                                            checked={formData?.adminApplyLeaveBehalfEmployee === "yes"}
                                                            onChange={() => handleRadioChange("admin_apply_leave_behalf_employee", "yes")}
                                                            className="form-check-input"
                                                        />
                                                        <label htmlFor="admin_apply_leave_behalf_employee_yes" className="form-check-label">Yes</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="admin_apply_leave_behalf_employee_no"
                                                            name="admin_apply_leave_behalf_employee"
                                                            value="no"
                                                            checked={formData?.adminApplyLeaveBehalfEmployee === "no"}
                                                            onChange={() => handleRadioChange("admin_apply_leave_behalf_employee", "no")}
                                                            className="form-check-input"
                                                        />
                                                        <label htmlFor="admin_apply_leave_behalf_employee_no" className="form-check-label">No</label>
                                                    </div>
                                                </div> */}
                                                {/* Admin to delete the approved request Setting */}
                                                {/* <div className="col-md-6 mt-4 settings-section">
                                                    <div>
                                                        <label>Provision for Admin to delete the approved request. So that Employee can reapply</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="admin_access_to_delete_approved_request_yes"
                                                            name="admin_access_to_delete_approved_request"
                                                            value="1"
                                                            checked={formData?.adminAccessToDeleteApprovedRequest === "1"}
                                                            onChange={() => handleRadioChange("admin_access_to_delete_approved_request", "1")}
                                                            className="form-check-input"
                                                        />
                                                        <label htmlFor="admin_access_to_delete_approved_request_yes" className="form-check-label">Yes</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="admin_access_to_delete_approved_request_no"
                                                            name="admin_access_to_delete_approved_request"
                                                            value="0"
                                                            checked={formData?.adminAccessToDeleteApprovedRequest === "0"}
                                                            onChange={() => handleRadioChange("admin_access_to_delete_approved_request", "0")}
                                                            className="form-check-input"
                                                        />
                                                        <label htmlFor="admin_access_to_delete_approved_request_no" className="form-check-label">No</label>
                                                    </div>
                                                </div> */}
                                                <div className="card-header align-items-center d-flex mt-5">
                                                    <h4 className="card-title mb-0 flex-grow-1">Leave Notification Settings</h4>
                                                </div>
                                                <div className="col-md-6 mt-3 settings-section">
                                                    <div>
                                                        <label>Should the Level1 RM receive a notification for every request on</label>
                                                    </div>
                                                    <div className="form-check">
                                                        <input
                                                            type="checkbox"
                                                            id="level1_rm_notification1"
                                                            name="level1_rm_notification1"
                                                            value="1"
                                                            checked={formData?.level1_rm_notification[0] === '1'}
                                                            onChange={() => handleRadioChange('level1_rm_notification', '1')}
                                                            className="form-check-input"
                                                        />
                                                        <label htmlFor="level1_rm_notification1" className="form-check-label">a) Mobile</label>
                                                    </div>
                                                    {/* <div className="form-check">
                                                        <input
                                                            type="checkbox"
                                                            id="level1_rm_notification2"
                                                            name="level1_rm_notification2"
                                                            value="1"
                                                            checked={formData?.level1_rm_notification[1] === '1'}
                                                            onChange={(e) => handleRadioChange('level1_rm_notification', '2')}
                                                            className="form-check-input"
                                                        />
                                                        <label htmlFor="level1_rm_notification2" className="form-check-label">b) Web</label>
                                                    </div> */}
                                                    <div className="form-check">
                                                        <input
                                                            type="checkbox"
                                                            id="level1_rm_notification3"
                                                            name="level1_rm_notification3"
                                                            value="1"
                                                            checked={formData?.level1_rm_notification[2] === '1'}
                                                            onChange={(e) => handleRadioChange('level1_rm_notification', '3')}
                                                            className="form-check-input"
                                                        />
                                                        <label htmlFor="level1_rm_notification3" className="form-check-label">b) Email</label>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 mt-3 settings-section">
                                                    <div>
                                                        <label>Should the Level2 RM receive a notification for every request on</label>
                                                    </div>
                                                    <div className="form-check">
                                                        <input
                                                            type="checkbox"
                                                            id="level2_rm_notification1"
                                                            name="level2_rm_notification1"
                                                            value="1"
                                                            checked={formData?.level2_rm_notification[0] === '1'}
                                                            onChange={() => handleRadioChange('level2_rm_notification', '1')}
                                                            className="form-check-input"
                                                        />
                                                        <label htmlFor="level2_rm_notification1" className="form-check-label">a) Mobile</label>
                                                    </div>
                                                    {/* <div className="form-check">
                                                        <input
                                                            type="checkbox"
                                                            id="level2_rm_notification2"
                                                            name="level2_rm_notification2"
                                                            value="2"
                                                            checked={formData?.level2_rm_notification[1] === '1'}
                                                            onChange={(e) => handleRadioChange('level2_rm_notification', '2')}
                                                            className="form-check-input"
                                                        />
                                                        <label htmlFor="level2_rm_notification2" className="form-check-label">b) Web</label>
                                                    </div> */}
                                                    <div className="form-check">
                                                        <input
                                                            type="checkbox"
                                                            id="level2_rm_notification3"
                                                            name="level2_rm_notification3"
                                                            value="2"
                                                            checked={formData?.level2_rm_notification[2] === '1'}
                                                            onChange={(e) => handleRadioChange('level2_rm_notification', '3')}
                                                            className="form-check-input"
                                                        />
                                                        <label htmlFor="level2_rm_notification3" className="form-check-label">b) Email</label>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 mt-5 settings-section">
                                                    <div>
                                                        <label>Should the employee receive a notification for every approval on</label>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-4">
                                                            <div className="form-check">
                                                                <input
                                                                    type="checkbox"
                                                                    id="employee_approval_notification1"
                                                                    name="employee_approval_notification1"
                                                                    value="1"
                                                                    checked={formData?.employeeApprovalNotification[0] === '1'}
                                                                    onChange={() => handleRadioChange('employee_approval_notification', '1')}
                                                                    className="form-check-input"
                                                                />
                                                                <label htmlFor="employee_approval_notification1" className="form-check-label">a) Mobile</label>
                                                            </div>
                                                            {/* <div className="form-check">
                                                                <input
                                                                    type="checkbox"
                                                                    id="employee_approval_notification2"
                                                                    name="employee_approval_notification2"
                                                                    value="2"
                                                                    checked={formData?.employeeApprovalNotification[1] === '1'}
                                                                    onChange={(e) => handleRadioChange('employee_approval_notification', '2')}
                                                                    className="form-check-input"
                                                                />
                                                                <label htmlFor="employee_approval_notification2" className="form-check-label">b) Web</label>
                                                            </div> */}
                                                            <div className="form-check">
                                                                <input
                                                                    type="checkbox"
                                                                    id="employee_approval_notification3"
                                                                    name="employee_approval_notification3"
                                                                    value="2"
                                                                    checked={formData?.employeeApprovalNotification[2] === '1'}
                                                                    onChange={(e) => handleRadioChange('employee_approval_notification', '3')}
                                                                    className="form-check-input"
                                                                />
                                                                <label htmlFor="employee_approval_notification3" className="form-check-label">b) Email</label>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-check">
                                                                <input
                                                                    type="checkbox"
                                                                    id="approval_level_notification1"
                                                                    name="approval_level_notification1"
                                                                    value="1"
                                                                    checked={formData?.approvalLevelNotification === '1' || formData?.approvalLevelNotification === '2'}
                                                                    onChange={() => handleRadioChange('approval_level_notification', '1')}
                                                                    className="form-check-input"
                                                                />
                                                                <label htmlFor="approval_level_notification1" className="form-check-label">Level1</label>
                                                            </div>
                                                            <div className="form-check">
                                                                <input
                                                                    type="checkbox"
                                                                    id="approval_level_notification2"
                                                                    name="approval_level_notification2"
                                                                    value="2"
                                                                    checked={formData?.approvalLevelNotification === '2'}
                                                                    onChange={(e) => handleRadioChange('approval_level_notification', `${e.target.checked ? 2 : 1}`)}
                                                                    className="form-check-input"
                                                                />
                                                                <label htmlFor="approval_level_notification2" className="form-check-label">Level2</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 mt-5 settings-section">
                                                    <div>
                                                        <label>Should the employee receive a notification for every rejection on</label>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-4">
                                                            <div className="form-check">
                                                                <input
                                                                    type="checkbox"
                                                                    id="employee_rejection_notification1"
                                                                    name="employee_rejection_notification1"
                                                                    value="1"
                                                                    checked={formData?.employeeRejectionNotification[0] === '1'}
                                                                    onChange={() => handleRadioChange('employee_rejection_notification', '1')}
                                                                    className="form-check-input"
                                                                />
                                                                <label htmlFor="employee_rejection_notification1" className="form-check-label">a) Mobile</label>
                                                            </div>
                                                            {/* <div className="form-check">
                                                                <input
                                                                    type="checkbox"
                                                                    id="employee_rejection_notification2"
                                                                    name="employee_rejection_notification2"
                                                                    value="1"
                                                                    checked={formData?.employeeRejectionNotification[1] === '1'}
                                                                    onChange={(e) => handleRadioChange('employee_rejection_notification', '2')}
                                                                    className="form-check-input"
                                                                />
                                                                <label htmlFor="employee_rejection_notification2" className="form-check-label">b) Web</label>
                                                            </div> */}
                                                            <div className="form-check">
                                                                <input
                                                                    type="checkbox"
                                                                    id="employee_rejection_notification3"
                                                                    name="employee_rejection_notification3"
                                                                    value="1"
                                                                    checked={formData?.employeeRejectionNotification[2] === '1'}
                                                                    onChange={(e) => handleRadioChange('employee_rejection_notification', '3')}
                                                                    className="form-check-input"
                                                                />
                                                                <label htmlFor="employee_rejection_notification3" className="form-check-label">c) Email</label>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-check">
                                                                <input
                                                                    type="checkbox"
                                                                    id="rejection_level_notification1"
                                                                    name="rejection_level_notification1"
                                                                    value="1"
                                                                    checked={formData?.rejectionLevelNotification === '1' || formData?.rejectionLevelNotification === '2'}
                                                                    onChange={() => handleRadioChange('rejection_level_notification', '1')}
                                                                    className="form-check-input"
                                                                />
                                                                <label htmlFor="rejection_level_notification1" className="form-check-label">Level1</label>
                                                            </div>
                                                            <div className="form-check">
                                                                <input
                                                                    type="checkbox"
                                                                    id="rejection_level_notification2"
                                                                    name="rejection_level_notification2"
                                                                    value="2"
                                                                    checked={formData?.rejectionLevelNotification === '2'}
                                                                    onChange={(e) => handleRadioChange('rejection_level_notification', `${e.target.checked ? 2 : 1}`)}
                                                                    className="form-check-input"
                                                                />
                                                                <label htmlFor="rejection_level_notification2" className="form-check-label">Level2</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* { decodedData?.includes(3) && (
                                                <div style={{ marginTop: "30px", marginLeft: 'Auto' }}>
                                                                {!postLoading ?
                                                                 <SubmitBtn icon="ri-save-line" text={formData?.leave_setting_id ? "Update" : "Save"} type={`primary`} /> :
                                                                <button disabled={true}
                                                                 className={`btn btn-primary btn-label waves-effect right waves-light float-right`}>
                                                                <i className={`ri-save-line label-icon align-middle fs-16 ms-2`} />{" "}
                                                                Loading...
                                                                 </button>
                                                                 }
                                                                </div>
                                                )} */}             
                                                {/* <button type='submit' >Save</button> */}
                                                {/* <div style={{ marginTop: "30px", marginLeft: 'Auto' }}>
                                                    {!postLoading ?
                                                        <SubmitBtn icon="ri-save-line" text={formData?.leave_setting_id == 0 ? "Save":"Update"} type={`primary`} /> :
                                                        <button disabled={true}
                                                            className={`btn btn-primary btn-label waves-effect right waves-light float-right`}>
                                                            <i className={`ri-save-line label-icon align-middle fs-16 ms-2`} />{" "}
                                                            Loading...
                                                        </button>}

                                                </div> */}
                                            </form>
                                            {(decodedData?.includes(3)) && (
                                                <div style={{ marginTop: "30px", marginLeft: "auto" }}>
                                                    {/* {!postLoading ? (
                                                        <button
                                                            onClick={(e)=>handleSubmit(e)}
                                                            disabled={!formData?.leave_setting_id}
                                                            className="btn btn-primary btn-label waves-effect right waves-light float-right"
                                                        >
                                                            <i className="ri-save-line label-icon align-middle fs-16 ms-2" />{" "}
                                                            {formData?.leave_setting_id === 0 ? "Save" : "Update"}
                                                        </button>
                                                    ) : (
                                                        <button className="btn btn-primary btn-label waves-effect right waves-light float-right">
                                                            <i className="ri-save-line label-icon align-middle fs-16 ms-2" />{" "}
                                                            {"Loading..."}
                                                        </button>
                                                    )} */}
                                                    <SubmitButton
                                                    onClick={(e)=> handleSubmit(e)}
                                                    loading={postLoading}
                                                    loadingMessage='loading' buttonName={formData?.leave_setting_id === 0 ? "Save" : "Update"} icon={'ri-save-line'} 
                                                    type='primary' iconSide='left' />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> :
                <div className='d-flex justify-content-center align-items-center' style={{ height: "90vh" }}>
                    <div className="text-center">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>

            }
        </div>
    );
}

export default LeaveGeneralSettings;
